import { useRouteError } from 'react-router-dom'
import { useEffect } from 'react'
import { captureException } from '../sentry'
import { SentryErrorFallback } from './SentryErrorFallback'

/**
 * Root Route Error Boundary component for React Router Data Router.
 * Traps route render/lifecycle errors captured by React Router,
 * reports them to Sentry via captureException(), and renders the reusable SentryErrorFallback UI.
 */
export function RootRouteErrorBoundary() {
  const error = useRouteError()

  useEffect(() => {
    if (error) {
      captureException(error, { tags: { source: 'ReactRouterRouteBoundary' } })
    }
  }, [error])

  return (
    <SentryErrorFallback
      error={error instanceof Error ? error : new Error(String(error || 'Unknown Route Error'))}
      resetError={() => window.location.reload()}
    />
  )
}

export default RootRouteErrorBoundary
